
import './Profile.scss';

//import { Button} from '@mui/material';
//import {ThemeProvider } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ProfilPersonnelClient, { typeEnum } from '../../Components/shared/ProfilPersonnelClient';
//import useUtilities from '../../hooks/useUtilities';

//PS backend client/getMyInfos

function Profile() {
    const { i18n } = useTranslation();
    return (
        <>
            <div className='frame5Profile'>{i18n.t('Mon Compte')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Profil personnel')} </span> </div>
            <ProfilPersonnelClient
                type={typeEnum.update}
                titre='Profil personnel'
            />
        </>
    );
}

export default Profile;
